import React, { useContext } from 'react';
import { store } from '../../store/store';
import { SettingsPage } from './SettingsPage';

export const SettingsPageContainer = () => {
  const { state } = useContext(store);

  return <SettingsPage email={state.currentUser?.attributes.email} />;
};
